import React from 'react';
import { Link } from 'react-router-dom';

import { CATERING_EVENT_LINKS, CATERING_CUISINE_LINKS, CATERING_PLANNING_LINKS } from './navLinks';
import styles from './MegaMenu.module.postcss';

function CateringMenu({ vehicleType }) {
  return (
    <div className={styles.MegaMenu_grid}>
      <div className={styles.MegaMenu_column}>
        <strong className={styles.MegaMenu_heading}>By cuisine</strong>
        <ul>
          { CATERING_CUISINE_LINKS.map((link) => (
            <li key={link.url}>
              <Link to={link.url}>{link.emoji} {link.name}</Link>
            </li>
          ))}
        </ul>
      </div>

      <div className={styles.MegaMenu_column}>
        <strong className={styles.MegaMenu_heading}>By event</strong>
        <ul>
          { CATERING_EVENT_LINKS.map((link) => (
            <li key={link.url}>
              <Link to={link.url}>{link.name}</Link>
            </li>
          ))}
        </ul>
        <Link to='/food-truck-catering/prices' className={styles.MegaMenu_viewAll}>
          Catering prices
        </Link>
      </div>

      <div className={styles.MegaMenu_column}>
        <strong className={styles.MegaMenu_heading}>Planning &amp; booking</strong>
        <ul>
          { CATERING_PLANNING_LINKS.map((link) => (
            <li key={link.url}>
              <Link to={link.url}>{link.name}</Link>
            </li>
          ))}
        </ul>
        <Link to='/catering/requests/new' className={styles.MegaMenu_viewAll}>
          Get a free quote
        </Link>
      </div>
    </div>
  );
}

export default React.memo(CateringMenu);
